import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import Col from "react-bootstrap/esm/Col";

import { alunos_andamento, agendamentos } from "../../services/api";

const Alunos_Andamento = (props) => {

    const [dataA, setDataA] = useState([]);
    const [status, setStatus] = useState(true);
    const [dataAgenda, setDataAgenda] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;


    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const situacao = ['', '', '', '', '', 'Presencial - Pgt Pendente', 'Presencial - Doc Pendente', 'Remoto - Pgt Pendente', 'Remoto - Doc Pendente', 'Remoto Conf. Pgt']


    const fetchData = async () => {
        try {
            const response = await alunos_andamento(data_inicio, data_fim, cod_unidade);
            setDataA(response);
            const response2 = await agendamentos(cod_unidade, status);
            console.log('agenda', response2)
            setDataAgenda(response2);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    let dadosdiltrados2 = []

    console.log("dataA", dataA)


    const handleStatus = (e) => {
        e.preventDefault();
        setStatus(!status);
    };

    if (typeof dataA !== 'undefined') {
        // dadosdiltrados = data3.filter(item => item.bolsas === filtro);
        dadosdiltrados2 = dataA.map((item, index) => {
            const row = [situacao[parseInt(item.sit)]];
            row.push(item.matricula);
            row.push(item.nome);
            row.push(item.turma);
            row.push(item.resp_finan);
            row.push(item.email_resp_finan);
            return row;
        });
    };

    dadosdiltrados2.unshift(['SITUAÇÃO', 'MATRICULA', 'NOME', 'TURMA', 'RESPONSÁVEL FINANCEIRO', 'E-MAIL DO RESPONSÁVEL']);

    let chartDataAgenda = [];

    if (typeof dataAgenda !== 'undefined') {
        // dadosdiltrados = data3.filter(item => item.bolsas === filtro);
        chartDataAgenda = dataAgenda.map((item, index) => {
            const row = [item.unidade];

            const timestampOriginal = new Date(item.agendamento);
            timestampOriginal.setHours(timestampOriginal.getHours() - 3);
            let timestamp = timestampOriginal.toISOString();
            timestamp = timestamp.replace("T", " ");
            timestamp = timestamp.replace(".000Z", " ");
            row.push(timestamp);

            row.push(item.matricula);
            row.push(item.aluno);
            row.push(item.contratante1);
            row.push(item.email);
            row.push(item.telefone);
            return row;
        });
    };

    chartDataAgenda.unshift(['UNIDADE', 'AGENDAMENTO', 'MATRICULA', 'ALUNO', 'RESPONSÁVEL', 'E-MAIL', 'TELEFONE']);

    const options = {
        allowHtml: true,
        page: 'enable',
        pageSize: 15,


    };

    console.log("dadosdiltrados2", dadosdiltrados2)

    return (
        <div className="andamento">
            <Chart
                chartType="Table"
                width="100%"
                version="current"
                data={dadosdiltrados2}
                options={options}
                chartWrapperParams={{ view: { columns: [0, 1, 2, 3, 4, 5] } }}
                chartPackages={["corechart", "controls"]}
                controls={[
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 0,
                            ui: {
                                labelStacking: "vertical",
                                label: "Situação",
                                allowTyping: false,
                                allowMultiple: false,
                            },
                        },
                    },
                ]}
            />


            <h2>
                Agendamentos
            </h2>
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDataAgenda}
                options={options}

            />


        </div>
    )

}
export default Alunos_Andamento;